import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from "@ngrx/store";
import { EntityId, IPerson } from "src/app/interfaces";
import { nameOf } from "src/app/interfaces/string";
import * as AppState from "../../state/app.state";
import * as fromPerson from "./person.reducer";

export const featureName = "person";
export interface State extends AppState.State {
  person: fromPerson.PersonState;
}

nameOf<State>(featureName); // Ensures featureName property

// Selector functions
const selectPersonState =
  createFeatureSelector<fromPerson.PersonState>(featureName);

export const selectPersonEntities = createSelector(
  selectPersonState,
  fromPerson.selectPersonEntities
);

export const selectAllPersons = createSelector(
  selectPersonState,
  fromPerson.selectAllPersons
);

export const selectPerson = (
  id: string | number
): MemoizedSelector<State, IPerson> =>
  createSelector(selectPersonEntities, (persons) => persons[id]);

export const selectPersonByLogin = (
  login: EntityId
): MemoizedSelector<State, IPerson> =>
  createSelector(selectAllPersons, (persons) =>
    persons.find((p) => p.login === login)
  );

export const selectPersonError = createSelector(
  selectPersonState,
  (state) => state.error
);
